import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getBaseUrl } from "../utils/apiHelper";

const VerifyCodeLink = () => {
  const location = useLocation();
  const [status, setStatus] = useState(null); // 'success', 'fail', 'expired', etc.
  const [message, setMessage] = useState("Verifying...");
  const [resendStatus, setResendStatus] = useState("");
  const [emailParam, setEmailParam] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    setEmailParam(email || "");
    const code = params.get("code");
    if (!email || !code) {
      setStatus("fail");
      setMessage("Missing email or code in the link.");
      return;
    }
    // Call backend to verify
    fetch(`${getBaseUrl()}/api/auth/verify-code`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, code })
    })
      .then(async res => {
        const data = await res.json();
        if (res.ok) {
          setStatus("success");
          setMessage("✅ Email verified! You can now log in.");
        } else {
          setStatus("fail");
          if (data.message && data.message.toLowerCase().includes("expired")) {
            setStatus("expired");
            setMessage("❌ Verification code expired. Please request a new one.");
          } else if (data.message && data.message.toLowerCase().includes("invalid")) {
            setMessage("❌ Invalid verification code.");
          } else {
            setMessage(data.message || "Verification failed.");
          }
        }
      })
      .catch(() => {
        setStatus("fail");
        setMessage("Verification failed. Please try again later.");
      });
  }, [location.search]);

  const handleResend = async () => {
    setResendStatus("Sending...");
    try {
      const res = await fetch(`${getBaseUrl()}/api/auth/send-verification-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: emailParam })
      });
      const data = await res.json();
      if (res.ok) {
        setResendStatus("Verification code resent! Check your email.");
      } else {
        setResendStatus(data.message || "Failed to resend code.");
      }
    } catch (err) {
      setResendStatus("Failed to resend code.");
    }
  };

  return (
    <div className="form-container" style={{textAlign:'center',marginTop:40}}>
      <h2>Email Verification</h2>
      <div style={{fontSize:32, color: status === 'success' ? '#008000' : '#b30000', marginBottom:16}}>
        {status === 'success' ? '✅' : '❌'}
      </div>
      <p style={{color: status === 'success' ? '#008000' : '#b30000', fontWeight:'bold', fontSize:18}}>{message}</p>
      {(status === 'fail' || status === 'expired') && emailParam && (
        <div style={{marginTop:24}}>
          <button onClick={handleResend} style={{padding:'10px 20px',borderRadius:6,background:'#0080ff',color:'#fff',border:'none',cursor:'pointer',fontWeight:'bold'}}>Resend Verification Code</button>
          {resendStatus && <div style={{marginTop:10, color:'#008000'}}>{resendStatus}</div>}
        </div>
      )}
    </div>
  );
};

export default VerifyCodeLink;
